const classusables = {
  'fill-color': '#B92626',
  'fill-opacity': 0.8,
  'fill-outline-color': '#000000',
  'fill-outline-opacity': 1,
  labels: {
    attributes: ['best_label'],
    'font-color': '#000000',
    'font-size': 12,
    'font-weight': 'normal',
    maxzoom: null,
    minzoom: 1,
    'offset-x': 0,
    'offset-y': 0,
    'stroke-color': '#FFFFFF',
    'stroke-visible': true,
    'stroke-width': 3,
  },
  'line-dash': [],
  'line-width': 1,
  minzoom: 10,
  order: 7,
  uniques: {
    property: 'best_label',
    values: {
      PsIV: {
        'fill-color': '#FFCD33',
        'fill-opacity': 0.8,
        'fill-outline-color': '#000000',
        'fill-outline-opacity': 1,
        label: 'PsIV',
        labels: {
          attributes: ['best_label'],
          'font-color': '#000000',
          'font-size': 12,
          'font-weight': 'normal',
          maxzoom: null,
          minzoom: 1,
          'offset-x': 0,
          'offset-y': 0,
          'stroke-color': '#FFFFFF',
          'stroke-visible': true,
          'stroke-width': 3,
        },
        'line-dash': [],
        'line-width': 1,
        minzoom: 10,
        order: 3,
        value: 'PsIV',
      },
      PsV: {
        'fill-color': '#FFCD33',
        'fill-opacity': 0.8,
        'fill-outline-color': '#000000',
        'fill-outline-opacity': 1,
        label: 'PsV',
        labels: {
          attributes: ['best_label'],
          'font-color': '#000000',
          'font-size': 12,
          'font-weight': 'normal',
          maxzoom: null,
          minzoom: 1,
          'offset-x': 0,
          'offset-y': 0,
          'stroke-color': '#FFFFFF',
          'stroke-visible': true,
          'stroke-width': 3,
        },
        'line-dash': [],
        'line-width': 1,
        minzoom: 10,
        order: 2,
        value: 'PsV',
      },
      PsVI: {
        'fill-color': '#FFCD33',
        'fill-opacity': 0.8,
        'fill-outline-color': '#000000',
        'fill-outline-opacity': 1,
        label: 'PsVI',
        labels: {
          attributes: ['best_label'],
          'font-color': '#000000',
          'font-size': 12,
          'font-weight': 'normal',
          maxzoom: null,
          minzoom: 1,
          'offset-x': 0,
          'offset-y': 0,
          'stroke-color': '#FFFFFF',
          'stroke-visible': true,
          'stroke-width': 3,
        },
        'line-dash': [],
        'line-width': 1,
        minzoom: 10,
        order: 5,
        value: 'PsVI',
      },
      RIV: {
        'fill-color': '#67B926',
        'fill-opacity': 0.8,
        'fill-outline-color': '#000000',
        'fill-outline-opacity': 1,
        label: 'RIV',
        labels: {
          attributes: ['best_label'],
          'font-color': '#000000',
          'font-size': 12,
          'font-weight': 'normal',
          maxzoom: null,
          minzoom: 1,
          'offset-x': 0,
          'offset-y': 0,
          'stroke-color': '#FFFFFF',
          'stroke-visible': true,
          'stroke-width': 3,
        },
        'line-dash': [],
        'line-width': 1,
        minzoom: 10,
        order: 5,
        value: 'RIV',
      },
      RIVa: {
        'fill-color': '#67B926',
        'fill-opacity': 0.8,
        'fill-outline-color': '#000000',
        'fill-outline-opacity': 1,
        label: 'RIVa',
        labels: {
          attributes: ['best_label'],
          'font-color': '#000000',
          'font-size': 12,
          'font-weight': 'normal',
          maxzoom: null,
          minzoom: 1,
          'offset-x': 0,
          'offset-y': 0,
          'stroke-color': '#FFFFFF',
          'stroke-visible': true,
          'stroke-width': 3,
        },
        'line-dash': [],
        'line-width': 1,
        minzoom: 10,
        order: 3,
        value: 'RIVa',
      },
      RIVb: {
        'fill-color': '#67B926',
        'fill-opacity': 0.8,
        'fill-outline-color': '#000000',
        'fill-outline-opacity': 1,
        label: 'RIVb',
        labels: {
          attributes: ['best_label'],
          'font-color': '#000000',
          'font-size': 12,
          'font-weight': 'normal',
          maxzoom: null,
          minzoom: 1,
          'offset-x': 0,
          'offset-y': 0,
          'stroke-color': '#FFFFFF',
          'stroke-visible': true,
          'stroke-width': 3,
        },
        'line-dash': [],
        'line-width': 1,
        minzoom: 10,
        order: 4,
        value: 'RIVb',
      },
      RV: {
        'fill-color': '#67B926',
        'fill-opacity': 0.8,
        'fill-outline-color': '#000000',
        'fill-outline-opacity': 1,
        label: 'RV',
        labels: {
          attributes: ['best_label'],
          'font-color': '#000000',
          'font-size': 12,
          'font-weight': 'normal',
          maxzoom: null,
          minzoom: 1,
          'offset-x': 0,
          'offset-y': 0,
          'stroke-color': '#FFFFFF',
          'stroke-visible': true,
          'stroke-width': 3,
        },
        'line-dash': [],
        'line-width': 1,
        minzoom: 10,
        order: 6,
        value: 'RV',
      },
      RVI: {
        'fill-color': '#67B926',
        'fill-opacity': 0.8,
        'fill-outline-color': '#000000',
        'fill-outline-opacity': 1,
        label: 'RVI',
        labels: {
          attributes: ['best_label'],
          'font-color': '#000000',
          'font-size': 12,
          'font-weight': 'normal',
          maxzoom: null,
          minzoom: 1,
          'offset-x': 0,
          'offset-y': 0,
          'stroke-color': '#FFFFFF',
          'stroke-visible': true,
          'stroke-width': 3,
        },
        'line-dash': [],
        'line-width': 1,
        minzoom: 10,
        order: 8,
        value: 'RVI',
      },
      ŁIV: {
        'fill-color': '#FFCD33',
        'fill-opacity': 0.8,
        'fill-outline-color': '#000000',
        'fill-outline-opacity': 1,
        label: 'ŁIV',
        labels: {
          attributes: ['best_label'],
          'font-color': '#000000',
          'font-size': 12,
          'font-weight': 'normal',
          maxzoom: null,
          minzoom: 1,
          'offset-x': 0,
          'offset-y': 0,
          'stroke-color': '#FFFFFF',
          'stroke-visible': true,
          'stroke-width': 3,
        },
        'line-dash': [],
        'line-width': 1,
        minzoom: 10,
        order: 0,
        value: 'ŁIV',
      },
      ŁV: {
        'fill-color': '#FFCD33',
        'fill-opacity': 0.8,
        'fill-outline-color': '#000000',
        'fill-outline-opacity': 1,
        label: 'ŁV',
        labels: {
          attributes: ['best_label'],
          'font-color': '#000000',
          'font-size': 12,
          'font-weight': 'normal',
          maxzoom: null,
          minzoom: 1,
          'offset-x': 0,
          'offset-y': 0,
          'stroke-color': '#FFFFFF',
          'stroke-visible': true,
          'stroke-width': 3,
        },
        'line-dash': [],
        'line-width': 1,
        minzoom: 10,
        order: 1,
        value: 'ŁV',
      },
      ŁVI: {
        'fill-color': '#FFCD33',
        'fill-opacity': 0.8,
        'fill-outline-color': '#000000',
        'fill-outline-opacity': 1,
        label: 'ŁVI',
        labels: {
          attributes: ['best_label'],
          'font-color': '#000000',
          'font-size': 12,
          'font-weight': 'normal',
          maxzoom: null,
          minzoom: 1,
          'offset-x': 0,
          'offset-y': 0,
          'stroke-color': '#FFFFFF',
          'stroke-visible': true,
          'stroke-width': 3,
        },
        'line-dash': [],
        'line-width': 1,
        minzoom: 10,
        order: 2,
        value: 'ŁVI',
      },
    },
  },
};

const default_temporary_polygon = {
  'line-dash': [],
  'fill-color': '#000000',
  'line-width': 2,
  'fill-outline-color': '#000000',
  'fill-outline-opacity': 1,
  'fill-opacity': 0.5,
  minzoom: 1,
  maxzoom: null,
  labels: { attributes: [] },
};

const default_temporary_linestring = {
  labels: { attributes: [] },
  minzoom: 1,
  'line-dash': [],
  'line-color': '#000000',
  'line-width': 2,
  'fill-opacity': 1,
};

const default_temporary_point = {
  'circle-color': '#000000',
  'circle-radius': 3,
  'fill-opacity': 1,
  labels: { attributes: [] },
  minzoom: 1,
};

const default_temporary_layer_style = {
  point: default_temporary_point,
  multipoint: default_temporary_point,
  polygon: default_temporary_polygon,
  multipolygon: default_temporary_polygon,
  linestring: default_temporary_linestring,
  multilinestring: default_temporary_linestring,
};

export { classusables, default_temporary_layer_style };
